import { render, staticRenderFns } from "./ContainerInbound.vue?vue&type=template&id=20cf9971"
import script from "./ContainerInbound.vue?vue&type=script&lang=js"
export * from "./ContainerInbound.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports